import type { SxProps, Theme } from '@mui/material/styles';

/**
 * The page-level card surface — sections, the entity header card, KPI tiles, the table card — as
 * the active variant draws it (`theme.eis.surface`, prompt 24 Phase 24.3). Patterns ask for this
 * instead of reading `radius` / `elevation` constants, so `berry` gets the EIS Design System card
 * (5px, the soft card shadow, no border) and `suite` keeps what prompt 22 gave it (12px, hairline
 * border and shadow) — without either pattern knowing which variant it is in.
 *
 * Spread onto a `Paper variant="outlined"`: the outline is suite's border, and berry removes it.
 */
export const cardSurfaceSx = (theme: Theme) => ({
  borderRadius: `${String(theme.eis.surface.cardRadius)}px`,
  boxShadow: theme.eis.surface.cardShadow,
  ...(theme.eis.surface.cardBorder ? {} : { border: 'none' }),
});

/** The same surface as an `sx` value, for a pattern that adds nothing to it. */
export const cardSurface: SxProps<Theme> = cardSurfaceSx;
